import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";

// Icons
export const AnankeTagIcon = "b612b17d-7e26-4d5c-b912-f67dccf10b8b" as Uuid;
export const AnankeDevicesIcon = "af0c21ac-1eb0-4fcb-b18e-7a975a1fb805" as Uuid;
export const AnankeStarUnstarredIcon = "680ef4d7-23f9-4a76-a26a-8af65dcfa0cc" as Uuid;
export const AnankeSubtasksIcon = "c984186e-f1c2-4bf7-bf5e-6108cc4e75ca" as Uuid;
export const AnankeChevronDownIcon = "ca0b7fc9-d9a1-4193-b67e-2a1259ce7989" as Uuid;
export const AnankeEmailIcon = "d1e2f3a4-b5c6-7d8e-9f0a-1b2c3d4e5f6a" as Uuid;
export const AnankeCalendarIcon = "e2f3a4b5-c6d7-8e9f-0a1b-2c3d4e5f6a7b" as Uuid;
export const AnankeBriefcaseIcon = "f3a4b5c6-d7e8-9f0a-1b2c-3d4e5f6a7b8c" as Uuid;
export const AnankeOfficeBuildingIcon = "a1b2c3d4-e5f6-7890-abcd-ef1234567890" as Uuid;
export const AnankeInformationCircleIcon = "d1489e2a-655d-47b7-b9e0-b360b07c1ed3" as Uuid;
export const AnankePersonAvatarIcon = "dfd90a76-c6fa-4273-bcb8-fd21cd82bf36" as Uuid;
export const AnankeLocationIcon = "c036c985-6454-446f-b03c-ab5287f7dff0" as Uuid;
export const AnankePersonIcon = "a924c49b-4a7e-4f59-81a4-c72441e578fd" as Uuid;
export const AnankeClockIcon = "2a4dd3e2-3c11-4d9f-b126-39bbad3f6f8d" as Uuid;
export const AnankeLinkExternalIcon = "edce6186-4cb7-41af-a14d-08df45b58ed8" as Uuid;
export const AnankeModelVariantIcon = "ad9af9a4-8828-4736-8a1f-5d8748f8c35f" as Uuid;
export const AnankeDatabaseStorageCacheIcon = "f4c8e2a1-9b3d-4f67-8c5e-1d2a3b4c5d6e" as Uuid;
export const AnankeServiceIcon = "a7b3c9d1-2e4f-5a6b-8c9d-0e1f2a3b4c5d" as Uuid;
